export const profile = {
  name: 'Yash Swaminathan',
  firstName: 'Yash',
  introduction: 'I enjoy taking complex problems and finding simple solutions.',
  university: 'University of Waterloo',
  program: 'Systems Design Engineering',
  term: '2B',
  email: 'yswamina@uwaterloo.ca',
  github: 'https://github.com/Yash-Swaminathan',
  linkedin: 'https://www.linkedin.com/in/yash-swaminathan',
  x: 'https://x.com/YashSwaminathan',
  resume: '/Yash_Swaminathan_Resume.pdf'
};

export const experiences = [
  {
    company: 'StackAdapt',
    title: 'Software Engineering Intern',
    period: 'May – Aug 2026',
    description: 'Infrastructure and backend engineering on the 1P Backend Integration team.',
    website: 'https://www.stackadapt.com'
  },
  {
    company: 'Micromart',
    title: 'Software Engineer Intern',
    period: 'Aug – Dec 2025',
    description: 'DevOps, infrastructure, and backend engineering focused on reliability and scalability.',
    website: 'https://www.micromart.com'
  },
  {
    company: 'Turing',
    title: 'Software Developer Intern',
    period: 'Jan – Apr 2025',
    description: 'Backend and DevOps work on scalable APIs and automation.',
    website: 'https://theturingcompany.com'
  },
  {
    company: 'Gradiant (Synauta)',
    title: 'Data Science Intern',
    period: 'Sep 2023 – Jan 2024',
    description: 'Data analytics and automation for IoT systems.',
    website: 'https://www.gradiant.com'
  }
];
